export const productsSummaryDefaultColumns = [
  { label: 'Produto', value: 'display_name' },
  { label: 'Transações', value: 'total_consumptions_count' },
  { label: 'Quantidade', value: 'total_quantity' },
  { label: 'Valor total', value: 'total_amount' },
];
